import { ClassUtils } from "../../utils/ClassUtils";
import { ColorUtils } from "../../utils/ColorUtils";
import { Pool } from "../../utils/Pool";
import { VertexStream } from "../../utils/VertexStream";
import { Rectangle } from "../../maths/Rectangle";
const className = "DrawTrianglesCmd";
export class DrawTrianglesCmd {
    constructor() {
        this.x = 0;
        this.y = 0;
    }
    static create(texture, x, y, vertices, uvs, indices, matrix, alpha, color, blendMode) {
        var cmd = Pool.getItemByClass(className, DrawTrianglesCmd);
        cmd.texture = texture;
        texture._addReference();
        cmd.x = x;
        cmd.y = y;
        cmd.vertices = vertices;
        cmd.uvs = uvs;
        cmd.indices = indices;
        cmd.matrix = matrix;
        cmd.alpha = alpha !== null && alpha !== void 0 ? alpha : 1;
        cmd.color = color != null ? ColorUtils.create(color).numColor : 0xffffffff;
        cmd.blendMode = blendMode;
        return cmd;
    }
    static create2(texture, mesh, color) {
        var cmd = Pool.getItemByClass(className, DrawTrianglesCmd);
        cmd.texture = texture;
        texture._addReference();
        cmd.x = 0;
        cmd.y = 0;
        cmd.mesh = mesh;
        cmd.color = color != null ? ColorUtils.create(color).numColor : 0xffffffff;
        return cmd;
    }
    recover() {
        var _a;
        (_a = this.texture) === null || _a === void 0 ? void 0 : _a._removeReference();
        this.texture = null;
        this.vertices = null;
        this.uvs = null;
        this.indices = null;
        this.matrix = null;
        this.mesh = null;
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        if (!this.texture)
            return;
        if (this.mesh) {
            if (!this.mesh)
                return;
            let vb = VertexStream.pool.take(this.texture);
            vb.contentRect.setTo(0, 0, runner.sprite.width, runner.sprite.height);
            if (this.color)
                vb.color.setABGR(this.color);
            try {
                this.mesh.onPopulateMesh(vb);
            }
            catch (e) {
                console.error(e);
            }
            runner.drawTriangles(this.texture, this.x + gx, this.y + gy, vb.getVertices(), vb.getUVs(), vb.getIndices(), this.matrix, this.alpha, this.blendMode, null, vb.getColors(), this.texture.uvrect);
            VertexStream.pool.recover(vb);
        }
        else {
            runner.drawTriangles(this.texture, this.x + gx, this.y + gy, this.vertices, this.uvs, this.indices, this.matrix, this.alpha, this.blendMode, this.color);
        }
    }
    get cmdID() {
        return DrawTrianglesCmd.ID;
    }
    getBounds(assembler) {
        Rectangle.TEMP.setTo(0, 0, assembler.width, assembler.height).getBoundPoints(assembler.points);
    }
}
DrawTrianglesCmd.ID = className;
ClassUtils.regClass(className, DrawTrianglesCmd);
